const ensureProtocol = (value: string): string => {
  if (!value) {
    return '';
  }

  const trimmed = value.trim();
  if (/^https?:\/\//i.test(trimmed)) {
    return trimmed;
  }

  return `https://${trimmed}`;
};

const sanitizeHostname = (hostname: string): string => {
  if (!hostname) {
    return 'vatli365.vn';
  }

  const lower = hostname.toLowerCase().replace(/^www\./, '');

  if (lower === 'localhost' || lower === '127.0.0.1') {
    return lower;
  }

  let normalized = lower.replace('vatli365.com', 'vatli365.vn');
  normalized = normalized.replace(/^qoder\./, '');
  normalized = normalized.replace(/^ebook\./, '');

  if (!normalized.endsWith('vatli365.vn')) {
    normalized = 'vatli365.vn';
  }

  return normalized;
};

const trimPathname = (pathname: string): string => {
  if (!pathname || pathname === '/') {
    return '';
  }

  return pathname.replace(/\/+$/, '');
};

/**
 * Chuẩn hóa URL của WordPress để luôn dùng domain vatli365.vn
 */
export function normalizeVatliUrl(
  input: string | undefined | null,
  fallback: string
): string {
  if (!input || typeof input !== 'string' || input.trim().length === 0) {
    return fallback;
  }

  try {
    const candidate = ensureProtocol(input);
    const url = new URL(candidate);
    const sanitizedHost = sanitizeHostname(url.hostname);
    const isLocalHost = sanitizedHost === 'localhost' || sanitizedHost === '127.0.0.1';

    if (!isLocalHost) {
      url.protocol = 'https:';
      url.port = '';
    }

    url.hostname = sanitizedHost;

    const pathname = trimPathname(url.pathname);
    return `${url.origin}${pathname}${url.search}${url.hash}`.replace(/\/+$/, '');
  } catch (error) {
    console.warn('[normalizeVatliUrl] Invalid URL detected, using fallback:', input, error);
    return fallback;
  }
}

/**
 * Lấy origin (domain + protocol) đã chuẩn hóa về vatli365.vn
 */
export function normalizeVatliOrigin(
  input: string | undefined | null,
  fallback: string
): string {
  const normalized = normalizeVatliUrl(input, fallback);
  try {
    const url = new URL(normalized);
    return url.origin;
  } catch (error) {
    console.warn('[normalizeVatliOrigin] Invalid URL detected, using fallback:', normalized, error);
    return fallback;
  }
}

